let hasApiCalled = false
export const updateNotificationsIsRead = async (
  dispatch: any,
  setUnreadNotifIds: any,
  updateNotificationsReadStatus: any,
  unReadNotifIds: string[],
) => {
  if (hasApiCalled) return
  if (unReadNotifIds.length === 0) return

  hasApiCalled = true
  const unReadNotifIdsCopy = JSON.parse(JSON.stringify(unReadNotifIds))
  dispatch(setUnreadNotifIds({ ids: [], clearAll: true }))
  await dispatch(
    updateNotificationsReadStatus({
      apiPayload: { isRead: true, notificationIds: unReadNotifIdsCopy },
      showLoader: false,
    }) as any,
  )
  hasApiCalled = false
}
